import { Box } from "@mui/material";
import { Outlet } from "react-router-dom";
import "./App.css";

function App() {
  return (
    <>
      <Box style={{ height: "100%" }}>
        <Outlet />
      </Box>
    </>
  );
}

export default App;
